<template>
  <div class="wrap">
    <h1 class="row">{{translate('rma')}} {{translate('number-symbol')}}:{{invoice.invoiceNumber}}</h1>
    <div class="row" style="width: 70%">
      <company-box
        :title="translate('customer')"
        :company="rfq.customerCompany"
        :companyDetail="rfq.customerCompanyDetail"
        :companyContact="rfq.customerContact"
        :translate="translate"
      />
    </div>
    <table class="row box-content">
      <tr class="table__row">
        <th><div class="title">{{translate('customer-order')}}:</div></th>
        <th><div class="title">{{translate('rma-date')}}:</div></th>
      </tr>
      <tr class="table__row">
        <td align="center"><div>{{invoice.po}}</div></td>
        <td align="center"><div>{{invoice.invoiceDate | toDate}}</div></td>
      </tr>
    </table>
    <table-list
      :columns="[
        {
          label: translate('qty'),
          renderColumn: (row) => row.qty
        },
        {
          label: translate('part-number'),
          renderColumn: (row) => row.part.partNumber
        },
        {
          label: translate('s/n'),
          renderColumn: (row) => row.partSN
        },
        {
          label: translate('description'),
          renderColumn: (row) => row.part.partDescription
        },
        {
          label: translate('condition'),
          renderColumn: (row) => row.condition.title
        },
        {
          label: translate('u/price'),
          renderColumn: (row) => $options.filters.toPrice(row.price)
        },
        {
          label: translate('total'),
          renderColumn: (row) => $options.filters.toPrice(row.price * row.qty)
        },
        {
          label: translate('currency'),
          renderColumn: (row) => row.currency.title
        }
      ]"
      :data="rfq3s"
    />
    <table class="row">
      <tr>
        <td style="width: 70%" valign="top">
          <div v-if="invoice.remark">
            <h3>{{translate('remarks')}}</h3>
            <p><span v-html="$options.filters.toTextarea(invoice.remark)"></span></p>
          </div>
        </td>
        <td>
          <table class="table-sum">
            <tr class="table__row">
              <td><div class="capitalize">{{translate('sub-total')}}:</div></td>
              <td><div>{{subTotal | toPrice}}</div></td></tr>
            <tr class="table__row">
              <td><div class="capitalize">{{translate('aog-fees')}}:</div></td>
              <td><div>{{invoice.aogCharges}}</div></td></tr>
            <tr class="table__row">
              <td><div class="capitalize">{{translate('bank-fees')}}:</div></td>
              <td><div>{{invoice.bankFees}}</div></td></tr>
            <tr class="table__row"><td>
              <div class="capitalize">{{translate('shipping')}}:</div></td>
              <td><div>{{invoice.shippingCharges}}</div></td></tr>
            <tr class="table__row">
              <td><div class="capitalize">{{translate('vat')}}% {{invoice.vat.vatValue | toPrice}}:</div></td>
              <td><div>{{vatSum | toPrice}}</div></td></tr>
            <tr class="box-content table__row">
              <td><div class="capitalize">{{translate('total')}}:</div></td>
              <td><strong>{{total | toPrice}}</strong></td></tr>
          </table>
        </td>
      </tr>
    </table>
    <div class="row">
      <div v-html="content.html1"></div>
    </div>
  </div>
</template>
<script>

import { toDate, toPrice, toTextarea } from '@/utils/filters'
import TableList from './components/table-list'
import CompanyBox from './components/company-box'

export default {
  name: 'PdfInvoice8',
  components: {
    'table-list': TableList,
    'company-box': CompanyBox
  },
  props: {
    translate: {
      type: Function
    },
    invoice: {
      type: Object
    },
    rfq: {
      type: Object
    },
    rfq3s: {
      type: Array
    },
    content: {
      type: Object
    }
  },
  computed: {
    invoiceBankSum () {
      return [this.invoice.aogCharges, this.invoice.bankFees, this.invoice.shippingCharges].filter(Boolean)
        .reduce((result, item) => result + Number(item), 0)
    },
    vatSum () {
      const vatPercent = (this.invoice.vat.vatValue || 0) / 100
      return (this.subTotal + this.invoiceBankSum) * vatPercent
    },
    subTotal () {
      return this.rfq3s.reduce((result, detail) => result + (detail.qty * detail.price), 0)
    },
    total () {
      return this.subTotal + this.invoiceBankSum + this.vatSum
    }
  },
  filters: {
    toPrice: toPrice,
    toDate: toDate,
    toTextarea: toTextarea
  }
}
</script>
